module.exports = __webpack_public_path__ + "static/img/adoption_movie_thum_02.5b88a6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/movie/adoption_movie_thum_02.jpg
// module id = vTaY
// module chunks = 0